import axios from 'axios';
import { Api, Url, Crypto } from '@/utils/';

// Android's ColorSet.DEFAULT (pulseColorPrimary, ...Dark, ...Light, pulseColorAccent) as the signed
// ARGB ints Android stores.
const DEFAULT_COLORS = {
    color: 0xFF1775D2 | 0,
    color_dark: 0xFF1665C0 | 0,
    color_light: 0xFF63A3FF | 0,
    color_accent: 0xFFFF6E40 | 0
};

export default class Folders {
    static get() {
        let constructed_url = Url.get('folders') + Url.getAccountParam();
        const promise = new Promise((resolve, reject) => {
            axios.get(constructed_url)
                .then(response => {
                    response = response.data;

                    // Decrypt Folder items
                    for (let i = 0; i < response.length; i++) {
                        const folder = Crypto.decryptFolder(response[i]);
                        if (folder != null)
                            response[i] = folder;
                    }

                    resolve(response);
                })
                .catch(response => Api.rejectHandler(response, reject));
        });

        return promise;
    }

    /**
     * PULS-1424: as Android's FolderUtils.createAndShowFolder(). The server inserts the folder with
     * hand-built SQL (Folder.save_params), so every colour must be a number: a missing one breaks the
     * insert. The name is encrypted like every other field, and it never reaches that SQL as plain text.
     */
    static create(name) {
        const request = {
            folders: [
                {
                    device_id: Api.generateId(),
                    name: Crypto.encrypt(name),
                    ...DEFAULT_COLORS
                }
            ]
        };

        const constructed_url = Url.get('create_folder') + Url.getAccountParam();
        return axios.post(constructed_url, request, { 'Content-Type': 'application/json' })
            .catch(e => {
                Api.rejectHandler(e);
                throw e;
            });
    }

    // Only the name changes; the server keeps the colours it has.
    static update(id, name) {
        const constructed_url = Url.get('update_folder') + id + Url.getAccountParam();
        return axios.post(constructed_url, { name: Crypto.encrypt(name) }, { 'Content-Type': 'application/json' })
            .catch(e => {
                Api.rejectHandler(e);
                throw e;
            });
    }

    static delete(id) {
        let constructed_url = Url.get('remove_folder') + id + Url.getAccountParam();
        return axios.post(constructed_url)
            .catch(e => {
                Api.rejectHandler(e);
                throw e;
            });
    }
}
